/**
 * Keypad config enums
 */

export enum KeypadConfigType {
  INTEGER = 'integer',
  USER = 'user',
  PIN = 'pin',
  ITEM_COUNT = 'itemCount',
  ONLY_USER = 'onlyUser',
  WEIGHT = 'weight',
}
